import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface Props {
  type?: 'info' | 'success' | 'warning' | 'error';
  text?: string;
}

export const Toast = ({ type = 'success', text = 'error occured' }: Props) => {
  return toast[type](text, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  });
};
export default ToastContainer;
